import { render, staticRenderFns } from "./char-counter.vue?vue&type=template&id=0fc7b9e0"
import script from "./char-counter.vue?vue&type=script&lang=js"
export * from "./char-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports